import { ReactComponent as FbWhite }     from './fb_white.svg';
import { ReactComponent as InstaWhite }  from './insta_white.svg';
import { ReactComponent as Automation }  from './automation.svg';
import { ReactComponent as Box }         from './box.svg';
import { ReactComponent as Marketing }   from './marketing.svg';
import { ReactComponent as Simulations } from './simulations.svg';
import { ReactComponent as SubscribeArrow } from './subscribe_arrow.svg';
import { ReactComponent as Burger }         from './burger.svg';
import { ReactComponent as Close }          from './close.svg';
import { ReactComponent as FbGrey }         from './fb_grey.svg';
import { ReactComponent as InstaGrey }      from './insta_grey.svg';
import { ReactComponent as InstaBlack }     from './insta_black.svg';
import { ReactComponent as FbBlack }        from './fb_black.svg';
import { ReactComponent as CampaignAutomate } from './campaignAutomate.svg';
import { ReactComponent as CampaignAnalyze }  from './campaignAnalyze.svg';
import { ReactComponent as CampaignLaunch }   from './campaignLaunch.svg';
import { ReactComponent as CampaignKnow }     from './campaignKnow.svg';
import { ReactComponent as ArrowNormal }      from './arrowNormal.svg';
import { ReactComponent as ArrowDisabled }    from './arrowDisabled.svg';
import { ReactComponent as Done }             from './done-icon.svg';
import { ReactComponent as Cancel }           from './cancel.svg';
import { ReactComponent as Chevron }          from './chevron-down.svg';
import { ReactComponent as TooltipInfo }      from './tooltip_info.svg';
import { ReactComponent as CheckboxChecked }  from './checkbox.svg';
import { ReactComponent as CheckboxUnchecked } from './unchecked.svg';
import { ReactComponent as OrgUrl }            from './org-url.svg';
import { ReactComponent as LogoBlack }         from './roimax_logo_black.svg';
import { ReactComponent as LogoWhite }         from './roimax_logo_white.svg';

export default {
    FbWhite,
    InstaWhite,
    Automation,
    Box,
    Marketing,
    Simulations,
    SubscribeArrow,
    Burger,
    Close,
    FbGrey,
    InstaGrey,
    InstaBlack,
    FbBlack,
    CampaignAutomate,
    CampaignAnalyze,
    CampaignLaunch,
    CampaignKnow,
    ArrowNormal,
    ArrowDisabled,
    Done,
    Cancel,
    Chevron,
    TooltipInfo,
    CheckboxChecked,
    CheckboxUnchecked,
    OrgUrl,
    LogoBlack,
    LogoWhite
}